import {
  CLEAR_CREATE_LEAGUE,
  CREATE_LEAGUE_ERROR,
  CREATE_LEAGUE_LOADING,
  CREATE_LEAGUE_SUCCESS,
} from "../../../constant/actionTypes";

const createLeagueReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_LEAGUE_LOADING: {
      let obj = {
        loading: true,
      };
      return obj;
    }
    case CREATE_LEAGUE_SUCCESS: {
      let obj = {
        loading: false,
        data: action.response,
      };
      return obj;
    }
    case CREATE_LEAGUE_ERROR: {
      let obj = {
        loading: false,
        status: action.response,
      };
      return obj;
    }
    case CLEAR_CREATE_LEAGUE: {
      let obj = {};
      return obj;
    }
    default:
      return state;
  }
};

export default createLeagueReducer;
